import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, selectUser } from "../../ReduxStore/userReducer";
// import { resetItemGroup, resetItems } from "../../ReduxStore/itemReducer";
import SearchIcon from '@mui/icons-material/Search';

import { resetItemGroup, resetItems } from "../../ReduxStore/actions";
import "./header.css"
import { useOutsideAlerter } from "../dropdownCloser/dropdownCloser";
import axios from "axios";
import { decryptUserInfo } from "../decryption/Decryption";
import { useNavigate } from "react-router-dom";
import { logout } from "../../APIServices/Login/loginSlice";
import { getDecryptedUser } from "../../itemPage/ItemPageShared/ItemUtils";
import UpiQrCode from "../qrCodeGenerator/upiQrCode";


const Header = ({ ItemInputChange, show, itemSearchTerm }) => {
    const navigate = useNavigate();
    const user = sessionStorage.getItem('user');
    // const encrpt = JSON.parse(user);
    let encrpt = null;

    try {
        if (user) {
            encrpt = JSON.parse(user);
        }
    } catch (e) {
        console.error("Failed to parse user data:", e);
        encrpt = null;
    }
    // useEffect(() => {
    //     console.log("Checking auth redirect:", { encrpt });

    //     if (!encrpt) {
    //         dispatch(logout());
    //         console.log("No user data found — redirecting to login");
    //         navigate('/', { replace: true });
    //     }
    // }, [encrpt, navigate]);

    const userData = getDecryptedUser() || []; 
    console.log("userData",userData);
    const UserName = userData[0]?.CardName || "";
    const CardCode = userData[0]?.CardCode || "";
    const CompanyName = userData[0]?.CompanyName || "";
    const databaseName = userData?.DBName || "";
    const jwtToken = userData?.JwtToken || "";
    const dispatch = useDispatch();
    const [userDropdown, setUserDropdown] = useState(false);
    const handleLogout = () => {
        console.log("Logging out...");
        // sessionStorage.removeItem('user');
        dispatch(logout());
        setTimeout(() => {
            console.log("Navigating to /");
            navigate('/', { replace: true });
        }, 0);
    };
    const handleUserHeader = () => {
        setUserDropdown(true);
 
    }
    const wrapperRef = React.useRef(null);
    useOutsideAlerter(wrapperRef, () => setUserDropdown(false));
    return (
        <div className="header d-flex justify-content-between position-sticky  align-items-center">
            <div className="headerLogo d-flex align-items-center">
                <img src="/headerlogo.png" alt="Logo" className="header-logo-img" />
                <div className="logo-text ml-3">
                    <span className="LogoColor">AUTHORIZED DISTRIBUTOR</span><br />
                    <span className="LogoColor">MK TRADE CENTRE KOZHIKODE</span>
                </div>
            </div>
            {show === "show" &&
                <div className="searchDiv">
                    <input type="text"
                        className="searchInput"
                        placeholder="Search"
                        // value={CustomerValue ? (CustomerCode + '-' + customerName) : searchTerm}
                        value={itemSearchTerm}
                        onChange={(e) => { ItemInputChange(e) }}
                    />
                    <span className="searchIconSpan"><SearchIcon /></span>
                </div>
            }
            <div>
                <div className="userheader" onClick={handleUserHeader}>
                    <span>{UserName?.charAt(0)}</span>
                </div>
                {userDropdown &&
                    <div className="userdropdown"   
                        ref={wrapperRef}>
                        <p className="headerCompany">{CompanyName}</p>
                        <hr className="headerHr" />
                        <p className="headerUsername">{UserName}</p>
                        {/* <UpiQrCode CardCode={CardCode} payeeName={UserName}/> */}
                        <button className="logout" onClick={handleLogout}>Logout</button>
                    </div>}
            </div>
        </div>
    );
}

export default Header